"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_PATH = exports.TRACKING_PARAMS = exports.TRACKING_PAGES = exports.TRACKING_NAME = exports.TRACKING_FLOW = exports.RESTRICTION_TEXT = exports.CTA_IDS = void 0;
var TRACKING_NAME = exports.TRACKING_NAME = {
  KYC_POP_SHOW: 'kyc_popup_show',
  KYC_POP_UP_CLICK: 'kyc_popup_click'
};
var TRACKING_PARAMS = exports.TRACKING_PARAMS = {
  DISMISS_POPUP: 'dismiss_popup',
  CONT_TO_CHAT: 'continue_to_chat'
};
var RESTRICTION_TEXT = exports.RESTRICTION_TEXT = 'restricted_conversation';
var TRACKING_PAGES = exports.TRACKING_PAGES = {
  ADPAGE: 'adpage',
  HP: 'homepage'
};
var TRACKING_PATH = exports.TRACKING_PATH = {
  HP: '/',
  ADPV: 'item'
};
var CTA_IDS = exports.CTA_IDS = {
  COMPLETE_KYC_TEXT: 'completeKycText',
  CHAT_LIMIT_OVER: 'chatLimitOver',
  MAKE_AN_OFFER: 'makeAnOffer',
  KYC_LIMIT_BREACH_TXT: 'kycLimitBreachDesc',
  KYC_COUNT_LEFT: 'kycCountLeftDesc',
  SELLER_KYC_COUNT_LEFT: 'sellerKycCountLeftDesc',
  SELLER_CAPTION: 'sellerCaption',
  TYPE_PRIMARY: 'primary',
  CONTINUE_TO_CHAT: 'continueToChat'
};
var TRACKING_FLOW = exports.TRACKING_FLOW = {
  LOW_THRESHOLD: 'low_threshold_popup',
  HIGH_THRESHOLD: 'high_threshold_popup'
};